"use strict";

exports.__esModule = true;
exports.ClassificationController = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _libTimeline = require("@vimana/lib-timeline");
var _Timeline = require("../../Timeline");
var _API = require("../../API");
var _Utils = require("../../../Utils");
var _Core = require("../../Core");
var _TimeContext = require("../../Time/TimeContext");
var _UI = require("../../../Utils/UI");
var _constants = require("./constants");
var _dec, _dec2, _class, _InnerClassificationController;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var _getStatesList = function getStatesList(cycles, plantStateActivities) {
  if (!cycles) {
    return [];
  }
  var states = new Set();
  cycles.forEach(function (cycle) {
    var stateId = cycle.value.state;
    var state = plantStateActivities.states.find(function (stateObj) {
      return stateObj.id === stateId;
    });
    state ? states.add(state) : null;
  });
  return (0, _Utils.sortStates)(Array.from(states));
};
var _getActivityList = function getActivityList(cycles, plantStateActivities, selectedStates) {
  if (!cycles) {
    return [];
  }
  var activities = [];
  // if activity exists use activity otherwise use state
  cycles.forEach(function (cycle) {
    var _cycle$value = cycle.value,
      activity = _cycle$value.activity,
      state = _cycle$value.state;
    var activityObject = Object.assign({
      disabled: false
    }, plantStateActivities.activities.find(function (act) {
      return act.id === activity;
    }));
    if (!activityObject.id) {
      activityObject = Object.assign({
        disabled: false,
        parent: state
      }, plantStateActivities.states.find(function (stateObj) {
        return stateObj.id === state;
      }));
    }
    if (selectedStates) {
      if (!selectedStates.some(function (s) {
        return s.id === state;
      })) {
        activityObject.disabled = true;
      } else {
        delete activityObject.disabled;
      }
    }
    activities.push(activityObject);
  });
  return (0, _Utils.sortArrayOfObjectsByKey)((0, _Utils.dedupeArray)(activities), "name");
};
var getSortedSetOfNames = function getSortedSetOfNames(array) {
  return new Set(array.sort(function (a, b) {
    var _a$name;
    return (_a$name = a.name) == null ? void 0 : _a$name.localeCompare(b.name);
  }).map(function (item) {
    return item.name;
  }));
};
var sameArrayMemberNames = function sameArrayMemberNames(array1, array2) {
  var set1 = getSortedSetOfNames(array1);
  var set2 = getSortedSetOfNames(array2);
  return array1.every(function (item) {
    return set2.has(item.name);
  }) && array2.every(function (item) {
    return set1.has(item.name);
  });
};
var InnerClassificationController = (_dec = _API.RestAPIContext.withContext, _dec2 = _TimeContext.TimeContext.withContext, _dec(_class = _dec2(_class = (0, _Core.withTranslator)(_class = (_InnerClassificationController = /*#__PURE__*/function (_Component) {
  function InnerClassificationController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      config: null,
      device: _this.props.device,
      interval: _this.props.interval,
      cycles: _this.props.cycles,
      selectedIntervals: [],
      plantStateActivities: _this.props.plantStateActivities,
      plantStateActivitiesDevices: _this.props.plantStateActivitiesDevices,
      isSplitterDialogOpen: false,
      availableStates: [],
      availableActivites: [],
      selectedStates: null,
      selectedActivities: [],
      selectedDurations: [],
      statesNotAllowedToClassify: {},
      getSelectedStates: function getSelectedStates() {
        return _this.state.selectedStates || [];
      },
      setSelectedStates: function setSelectedStates(selectedStates) {
        return _this.setState({
          selectedStates: selectedStates
        });
      },
      clearSelectedIntervals: function clearSelectedIntervals() {
        _this.setState({
          selectedIntervals: []
        });
      },
      getSelectedActivities: function getSelectedActivities() {
        return _this.state.selectedActivities;
      },
      setSelectedActivities: function setSelectedActivities(selectedActivities) {
        return _this.setState({
          selectedActivities: selectedActivities
        });
      },
      getSelectedDurations: function getSelectedDurations() {
        return _this.state.selectedDurations;
      },
      setSelectedDurations: function setSelectedDurations(selectedDurations) {
        return _this.setState({
          selectedDurations: selectedDurations
        });
      },
      getStatesList: function getStatesList() {
        if (!_this.props.cycles) {
          return [];
        }
        return _getStatesList(_this.props.cycles, _this.props.plantStateActivities);
      },
      getFilteredCyclesList: function getFilteredCyclesList() {
        return _this.state.cycles.filter(function (cycle) {
          var flag = true;
          if (_this.state.selectedStates) {
            flag = _this.state.selectedStates.some(function (state) {
              return state.id === cycle.value.state;
            });
          }
          if (_this.state.selectedActivities) {
            // cycle should contain both selected state and activity
            flag = flag && _this.state.selectedActivities.some(function (activity) {
              return activity.id === cycle.value.activity || activity.id === cycle.value.state;
            });
          }
          if (_this.state.selectedDurations) {
            flag = flag && _this.state.selectedDurations.some(function (durationRange) {
              var interval = durationRange.interval;
              var cycleDuration = cycle.interval.endMillis - cycle.interval.startMillis;
              return interval.startMillis <= cycleDuration && interval.endMillis >= cycleDuration;
            });
          }
          return flag;
        });
      },
      getActivityList: function getActivityList() {
        if (!_this.props.cycles) {
          return [];
        }
        return _getActivityList(_this.props.cycles, _this.props.plantStateActivities, _this.state.selectedStates);
      },
      toggleSplitterDialog: function toggleSplitterDialog() {
        _this.setState({
          isSplitterDialogOpen: !_this.state.isSplitterDialogOpen
        });
      },
      onSelect: function onSelect(intervals) {
        var selectedIntervals = intervals.slice().sort(_libTimeline.compareIntervals);
        _this.setState({
          selectedIntervals: selectedIntervals
        });
      },
      getSelectedCycles: function getSelectedCycles() {
        var _this$state = _this.state,
          cycles = _this$state.cycles,
          selectedIntervals = _this$state.selectedIntervals;
        if (selectedIntervals.length === 0) {
          return [];
        }
        var predicate = _libTimeline.createOverlappingPredicate.apply(void 0, selectedIntervals);
        return cycles.filter(predicate);
      },
      getStatesNotAllowedToBeClassified: function getStatesNotAllowedToBeClassified(id) {
        var statesNotAllowedToClassify = _this.state.statesNotAllowedToClassify;
        if (id === "classificationButtonList") {
          var _keys = Object.keys(statesNotAllowedToClassify);
          return _keys.reduce(function (acc, key) {
            var values = statesNotAllowedToClassify[key];
            values.forEach(function (value) {
              if (!acc.includes(value)) {
                acc.push(value);
              }
            });
            return acc;
          }, []);
        }
        if (id && _this.state.statesNotAllowedToClassify[id]) {
          return _this.state.statesNotAllowedToClassify[id];
        }
        var keys = Object.keys(statesNotAllowedToClassify);
        return _this.state.statesNotAllowedToClassify[keys[0]] ? _this.state.statesNotAllowedToClassify[keys[0]] : [];
      },
      setStatesNotAllowedToBeClassified: function setStatesNotAllowedToBeClassified(id, statesNotAllowedToClassify) {
        var _Object$assign;
        var stateIds = _this.state.statesNotAllowedToClassify;
        _this.setState({
          statesNotAllowedToClassify: Object.assign({}, stateIds, (_Object$assign = {}, _Object$assign[id] = statesNotAllowedToClassify, _Object$assign))
        });
      },
      canMergeSelected: function canMergeSelected() {
        var selectedIntervals = _this.state.selectedIntervals;
        if (selectedIntervals.length < 2) {
          return false;
        }
        var endMillis = selectedIntervals[0].endMillis;
        for (var i = 1; i < selectedIntervals.length; i++) {
          var startMillis = selectedIntervals[i].startMillis;
          if (startMillis - endMillis > 1) {
            return false;
          }
          endMillis = selectedIntervals[i].endMillis;
        }
        return true;
      },
      mergeSelected: function () {
        var _mergeSelected = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var _this$props, api, device, selectedCycles;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this$props = _this.props, api = _this$props.api, device = _this$props.device;
                if (_this.state.canMergeSelected()) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                selectedCycles = _this.state.getSelectedCycles();
                if (!(selectedCycles.length === 0)) {
                  _context.n = 2;
                  break;
                }
                return _context.a(2);
              case 2:
                return _context.a(2, api.post("/api/v3/enrich-input/", Object.assign({
                  plant: api.plantName,
                  tag: "UserEvent",
                  input_type: "classification",
                  device_uuid: device.uuid
                }, selectedCycles[0].value, {
                  start: new Date(selectedCycles[0].interval.startMillis),
                  end: new Date(selectedCycles[selectedCycles.length - 1].interval.endMillis)
                }))["catch"](function (error) {
                  console.error(error);
                }));
            }
          }, _callee);
        }));
        function mergeSelected() {
          return _mergeSelected.apply(this, arguments);
        }
        return mergeSelected;
      }(),
      splitCycles: function () {
        var _splitCycles = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(parts) {
          var _this$props2, api, device, data;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this$props2 = _this.props, api = _this$props2.api, device = _this$props2.device;
                data = parts.map(function (part) {
                  return Object.assign({
                    plant: api.plantName,
                    tag: "UserEvent",
                    input_type: "classification",
                    device_uuid: device.uuid
                  }, part.value, {
                    start: new Date(part.interval.startMillis),
                    end: new Date(part.interval.endMillis),
                    source: _constants.CLASSIFICATION_SOURCE_UI
                  });
                });
                return _context2.a(2, api.post("/api/v3/enrich-input/", data)["catch"](function (error) {
                  console.error(error);
                }));
            }
          }, _callee2);
        }));
        function splitCycles(_x) {
          return _splitCycles.apply(this, arguments);
        }
        return splitCycles;
      }(),
      classifySelected: function () {
        var _classifySelected = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(input) {
          var _this$props3, api, device, time, interval, translator, translate, currentWorkday, currentShift, _this$state2, selectedIntervals, cycles, isFromNow, selectedCycles, isIntervalInCurrentWorkday, isIntervalInCurrentShift, reclassify, response, body, _t;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                _this$props3 = _this.props, api = _this$props3.api, device = _this$props3.device, time = _this$props3.time, interval = _this$props3.interval, translator = _this$props3.translator;
                translate = translator.translate;
                currentWorkday = time.currentWorkday, currentShift = time.currentShift;
                _this$state2 = _this.state, selectedIntervals = _this$state2.selectedIntervals, cycles = _this$state2.cycles;
                if (!(selectedIntervals.length === 0)) {
                  _context3.n = 1;
                  break;
                }
                return _context3.a(2);
              case 1:
                isFromNow = device.currentCycleClassify === "FROMNOW";
                selectedCycles = _this.state.getSelectedCycles();
                isIntervalInCurrentWorkday = interval.endMillis >= currentWorkday.interval.endMillis;
                isIntervalInCurrentShift = interval.endMillis >= currentShift.interval.endMillis;
                reclassify = function reclassify(cycle) {
                  var body = {};
                  var oldValues = {
                    device_uuid: cycle.device,
                    state: cycle.value.state,
                    activity: cycle.value.activity,
                    tag: cycle.tag || "",
                    start: cycle.start,
                    end: cycle.end
                  };
                  var isLatestCycleInCycleList = (0, _reactFastCompare["default"])(cycles[cycles.length - 1], cycle);
                  var interval = cycle.interval;
                  if (isLatestCycleInCycleList && (isIntervalInCurrentWorkday || isIntervalInCurrentShift)) {
                    body = {
                      oldValues: oldValues,
                      plant: api.plantName,
                      tag: "UserEvent",
                      input_type: "classification",
                      device_uuid: device.uuid,
                      state: input.state ? input.state.id : undefined,
                      activity: input.activity ? input.activity.id : null,
                      source: _constants.CLASSIFICATION_SOURCE_UI
                    };
                    if (!isFromNow) {
                      body.start = new Date(interval.startMillis);
                    }
                  } else {
                    body = {
                      oldValues: oldValues,
                      plant: api.plantName,
                      tag: "UserEvent",
                      input_type: "classification",
                      device_uuid: device.uuid,
                      state: input.state ? input.state.id : undefined,
                      activity: input.activity ? input.activity.id : null,
                      source: _constants.CLASSIFICATION_SOURCE_UI,
                      start: new Date(interval.startMillis).toISOString(),
                      end: interval.endMillis === _libTimeline.END_OF_TIME ? undefined : new Date(interval.endMillis).toISOString()
                    };
                  }
                  return body;
                };
                _context3.p = 2;
                body = selectedCycles.map(reclassify);
                _context3.n = 3;
                return api.post("/api/v3/enrich-input/", body);
              case 3:
                response = _context3.v;
                _context3.n = 5;
                break;
              case 4:
                _context3.p = 4;
                _t = _context3.v;
                if (_t.status === 400) {
                  translate("OperatorPanelScreen.classify.duration.warning", "Cannot re-classify chosen cycle, because its duration is greater then 24 hours");
                } else {
                  (0, _UI.showWarningToaster)(translate("OperatorPanelScreen.classify.error.warning", "Something went wrong, please raise a ticket if the issue persists"));
                }
                console.error(_t);
              case 5:
                _this.state.clearSelectedIntervals();
                return _context3.a(2, response);
            }
          }, _callee3, null, [[2, 4]]);
        }));
        function classifySelected(_x2) {
          return _classifySelected.apply(this, arguments);
        }
        return classifySelected;
      }(),
      getBaseDurationSelectionItems: function getBaseDurationSelectionItems() {
        return _this.getBaseDurationSelectionItems();
      }
    };
    _this.getBaseDurationSelectionItems = function () {
      var translator = _this.props.translator;
      var translate = translator.translate;
      return [{
        name: translate("ClassificationController.duration.0-5", "0m - 5m"),
        id: "range:0-5",
        interval: {
          startMillis: 0,
          endMillis: 300000
        }
      }, {
        name: translate("ClassificationController.duration.5-10", "5m - 10m"),
        id: "range:5-15",
        interval: {
          startMillis: 300000,
          endMillis: 600000
        }
      }, {
        name: translate("ClassificationController.duration.10-15", "10m - 15m"),
        id: "range:10-15",
        interval: {
          startMillis: 600000,
          endMillis: 900000
        }
      }, {
        name: translate("ClassificationController.duration.15-30", "15m - 30m"),
        id: "range:15-30",
        interval: {
          startMillis: 900000,
          endMillis: 1800000
        }
      }, {
        name: translate("ClassificationController.duration.30-60", "30m - 60m"),
        id: "range:30-60",
        interval: {
          startMillis: 1800000,
          endMillis: 3600000
        }
      }, {
        name: translate("ClassificationController.duration.60-240", "1h - 4h"),
        id: "range:60-240",
        interval: {
          startMillis: 3600000,
          endMillis: 14400000
        }
      }, {
        name: translate("ClassificationController.duration.240-480", "4h - 8h"),
        id: "range:240-480",
        interval: {
          startMillis: 14400000,
          endMillis: 28800000
        }
      }, {
        name: translate("ClassificationController.duration.480-", "8h+"),
        id: "range:480-",
        interval: {
          startMillis: 28800000,
          endMillis: Number.MAX_SAFE_INTEGER
        }
      }];
    };
    return _this;
  }
  _inheritsLoose(InnerClassificationController, _Component);
  InnerClassificationController.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var device = _ref.device,
      interval = _ref.interval,
      cycles = _ref.cycles,
      plantStateActivities = _ref.plantStateActivities;
    if (device.uuid === prevState.device.uuid && interval.startMillis === prevState.interval.startMillis && interval.endMillis === prevState.interval.endMillis && cycles === prevState.cycles) {
      return null;
    }
    var selectedIntervals = prevState.selectedIntervals,
      selectedStates = prevState.selectedStates,
      selectedActivities = prevState.selectedActivities,
      selectedDurations = prevState.selectedDurations,
      availableStates = prevState.availableStates,
      availableActivites = prevState.availableActivites;
    var cyclesAreEqual = (0, _reactFastCompare["default"])(cycles, prevState.cycles);
    var shallUpdateSelectedItems = false;
    var states = _getStatesList(cycles, plantStateActivities);
    var activities = _getActivityList(cycles, plantStateActivities, states);
    if (!sameArrayMemberNames(availableStates, states) || !sameArrayMemberNames(availableActivites, activities)) {
      shallUpdateSelectedItems = true;
    }
    if (!cyclesAreEqual || !selectedStates || interval.startMillis !== prevState.interval.startMillis || interval.endMillis !== prevState.interval.endMillis || shallUpdateSelectedItems) {
      if (selectedStates == null || selectedStates.length === 0 || shallUpdateSelectedItems) {
        selectedStates = _getStatesList(cycles, plantStateActivities);
      }
      if (selectedActivities == null || selectedActivities.length === 0 || shallUpdateSelectedItems) {
        selectedActivities = _getActivityList(cycles, plantStateActivities, selectedStates);
      }
      if (selectedDurations == null || selectedDurations.length === 0) {
        selectedDurations = prevState.getBaseDurationSelectionItems();
      }
    }
    if (!cyclesAreEqual) {
      if (selectedIntervals.length > 0) {
        var intervals = [];
        if (cycles.length > 0) {
          var currentCycle = cycles[cycles.length - 1];
          for (var i = 0; i < selectedIntervals.length; i++) {
            var _interval = selectedIntervals[i];
            if (currentCycle.interval.startMillis === _interval.startMillis) {
              intervals.push(currentCycle.interval);
            } else {
              for (var j = 0; j < cycles.length; j++) {
                var cycle = cycles[j];
                if (cycle.interval.startMillis === _interval.startMillis && cycle.interval.endMillis === _interval.endMillis) {
                  intervals.push(_interval);
                  break;
                }
              }
            }
          }
        }
        selectedIntervals = intervals;
      }
    }
    return {
      device: device,
      interval: interval,
      cycles: cycles,
      selectedIntervals: selectedIntervals,
      selectedStates: selectedStates,
      selectedActivities: selectedActivities,
      selectedDurations: selectedDurations,
      availableStates: states,
      availableActivites: activities
    };
  };
  var _proto = InnerClassificationController.prototype;
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return InnerClassificationController;
}(_react.Component), _InnerClassificationController.defaultProps = {
  api: undefined,
  translator: undefined,
  time: undefined
}, _InnerClassificationController)) || _class) || _class) || _class);
/**
 * Controller for device cycle classifications.
 * @component
 */
// eslint-disable-next-line react/no-multi-comp
var ClassificationController = exports.ClassificationController = /*#__PURE__*/function (_Component2) {
  function ClassificationController() {
    var _this2;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _Component2.call.apply(_Component2, [this].concat(args)) || this;
    _this2.normalizeTimeline = (0, _Utils.memoize)(function (cycles) {
      return (0, _libTimeline.mergeTimelineItems)(cycles, contiguousCyclePredicate);
    });
    _this2.handleTimeline = function (_ref2) {
      var _ref2$data = _ref2.data,
        data = _ref2$data === void 0 ? [] : _ref2$data;
      return /*#__PURE__*/_react["default"].createElement(InnerClassificationController, {
        device: _this2.props.device,
        interval: _this2.props.interval,
        cycles: _this2.normalizeTimeline(data),
        plantStateActivities: _this2.props.plantStateActivities,
        plantStateActivitiesDevices: _this2.props.plantStateActivitiesDevices
      }, _this2.props.children);
    };
    return _this2;
  }
  _inheritsLoose(ClassificationController, _Component2);
  var _proto2 = ClassificationController.prototype;
  _proto2.render = function render() {
    var _this$props4 = this.props,
      device = _this$props4.device,
      interval = _this$props4.interval;
    return /*#__PURE__*/_react["default"].createElement(_Timeline.LiveTimelineQueryController, {
      timelineName: "time-series-classification",
      query: {
        device: device.uuid
      },
      interval: interval
    }, this.handleTimeline);
  };
  return ClassificationController;
}(_react.Component);
ClassificationController.displayName = "ClassificationController";
function contiguousCyclePredicate(a, b, timeline) {
  if (timeline.length === 1) {
    // The first cycle in the list should not be merged.
    return false;
  }
  if (a.value.state === b.value.state && a.value.activity === b.value.activity && a.interval.endMillis === b.interval.startMillis && b.interval.endMillis !== _libTimeline.END_OF_TIME) {
    return true;
  }
  return false;
}